/** @jsx React.DOM */
/**
 * Base page component.
 */
var React = require("react");

module.exports = React.createClass({displayName: 'exports',
  render: function () {
    return (/*jshint ignore:start */
      React.createElement("div", {className: "container"}, 
        this.props.children
      )
    /*jshint ignore:end */);
  }
});



/*****************
 ** WEBPACK FOOTER
 ** ./components/page/base.jsx
 ** module id = 99
 ** module chunks = 0
 **/